import { render } from "./PodcastsPage.vue?vue&type=template&id=4370c928&scoped=true"
import script from "./PodcastsPage.vue?vue&type=script&lang=js"
export * from "./PodcastsPage.vue?vue&type=script&lang=js"

import "./PodcastsPage.vue?vue&type=style&index=0&id=4370c928&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4370c928"]])

export default __exports__